import React from 'react';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { Modal, Form, Button, Typography, Divider } from 'antd';
import rootApi from '@utils/baseAPI/WrapperApi';
import { showError, showSuccess } from '@components/notification';
import CustomerSelect from '@components/Select/SelectCustomer';
import PartnerSelect from '@components/Select/SelectPartner';

const { Title } = Typography;

const DialogBindPartner = (props) => {
  const { depot, open, setOpen, refetch } = props;

  const { mutateAsync, isLoading } = useMutation(['bind-users'], (data) => {
    return rootApi.put(
      `/admin/depots/${depot?.depot_code}/bind-to-partner/${data?.partner_id?.value}`
    );
  });

  const formik = useFormik({
    initialValues: {
      user_ids: []
    },
    onSubmit: (values) => {
      mutateAsync(values)
        .then(() => {
          handleClose();
          showSuccess({ message: 'Gắn khách hàng trạm thành công' });
        })
        .catch((error) => {
          showError(error || 'Vui lòng liên hệ admin để được hỗ trợ');
        });
    }
  });

  const handleClose = () => {
    formik.resetForm();
    refetch();
    setOpen(false);
  };

  // Custom footer for the modal
  const modalFooter = (
    <>
      <Button onClick={handleClose} style={{ height: '36px' }}>
        Hủy
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        form="bind-owner-form" // Link button to form submission
        style={{ height: '36px', backgroundColor: '#2D9764' }}
        loading={isLoading}>
        Gán đối tác
      </Button>
    </>
  );

  return (
    <Modal
      title="Gán đối tác vào trạm sạc"
      visible={open}
      onCancel={handleClose}
      footer={modalFooter} // Set the custom footer
      width={600}>
      <Divider />
      <Form id="bind-owner-form" onFinish={formik.handleSubmit} layout="vertical">
        <Form.Item name="partner_id" rules={[{ required: true, message: 'Vui lòng chọn đối tác' }]}>
          <PartnerSelect
            onChange={(value, option) => {
              formik.setFieldValue('partner_id', value);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DialogBindPartner;
